import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { SectionLabel } from "./Primitives";
import FileCard from "./FileCard";
import FileModal from "./FileModal";

// Shows admin-uploaded materials attached to a lesson or kingdom.
export default function AttachedFiles({ attachType, slug }) {
  const [files, setFiles] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/files", { params: { attach_type: attachType, attach_slug: slug } })
      .then((r) => setFiles(r.data))
      .catch(() => {});
  }, [attachType, slug]);

  if (files.length === 0) return null;

  return (
    <div className="mt-12 no-print" data-testid="attached-files">
      <SectionLabel>Curriculum Materials</SectionLabel>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {files.map((f) => (
          <FileCard key={f.id} file={f} onOpen={setActive} />
        ))}
      </div>
      {active && <FileModal file={active} onClose={() => setActive(null)} />}
    </div>
  );
}
